import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  return {
    iAmLabel: formatMessage(messages.iAmLabel),
    isPatientOption: formatMessage(messages.isPatientOption),
    isFamilyMemberOption: formatMessage(messages.isFamilyMemberOption),
    isLegalGuardianOption: formatMessage(messages.isLegalGuardianOption),
    isOtherPersonOption: formatMessage(messages.isOtherPersonOption),
  };
};

export default useTranslations;
